import { BaseModal } from './BaseModal'

type Props = {
  isOpen: boolean
  handleClose: () => void
}

export const AboutModal = ({ isOpen, handleClose }: Props) => {
  return (
    <BaseModal title="O hře" isOpen={isOpen} handleClose={handleClose}>
      <p className="text-sm text-gray-500 dark:text-gray-300">
        České Wordle je založeno na projektu
        s otevřeným zdrojovým kódem, který lze{' '}
        <a
          href="https://github.com/cwackerfuss/react-wordle"
          className="underline font-bold"
          target="_blank" rel="nofollow noreferrer noopener"
        >
          najít na GitHubu
        </a>.
      </p>
    </BaseModal>
  )
}
